<template>
  <path pid="0" d="M17.85 2.29a1 1 0 00-.71-.29H8.86a1 1 0 00-.71.29L2.29 8.15a1 1 0 00-.29.71v8.28a1 1 0 00.29.71l5.86 5.86a1 1 0 00.71.29h8.28a1 1 0 00.71-.29l5.86-5.86a1 1 0 00.29-.71V8.86a1 1 0 00-.29-.71zM22 16.73L16.73 22H9.27L4 16.73V9.27L9.27 4h7.46L22 9.27z"/><path pid="1" d="M13 8a1 1 0 00-1 1v4a1 1 0 002 0V9a1 1 0 00-1-1z"/><circle pid="2" cx="13" cy="16" r="1"/>
</template>
